











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast';
import data from '../../../../../assets/emojis.json';
import shortid from 'shortid';


@Component({
	components: {
		Picker
	},
})
export default class EmojiPicker extends Vue {

	@Prop({default: false}) public show: boolean;

	public pickerId: string = '';

	public ei = new EmojiIndex(data, {recentLength: 8, exclude: ['flags', 'symbols']});

	public isUp: boolean = false;

	@Watch('show', {immediate: true})
	public displayPickerChange(to: boolean, from: boolean) {
		this.show = to;
		this.$nextTick(() => this.isUp = this.isEmojiPickerUp());
	}
	public addVariableToText(variable: any) {
		this.$emit('insertEmoji', variable);
	}

	public getEmojiPickerId() {
		return `emoji-picker-${this.pickerId}`;
	}
	public beforeMount() {
		this.pickerId = shortid.generate();
	}
	private isEmojiPickerUp() {
		const menu = document.querySelector(`#${this.getEmojiPickerId()}`);
		if (menu) {
			const position = menu.getBoundingClientRect();
			const padding = 10;
			if (position.bottom > window.innerHeight - padding) {
				return true;
			}
		}
		return false;
	}




}
